import { CASE_SIDEBAR_SECTIONS } from '../config/sections';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { getAvailablePagesForStatus } from './statusPages';
import { isItemVisible } from './itemVisibility';
import type { CaseSidebarFeatureFlags } from '../types';
import { CaseSidebarItemId, CaseSidebarSection } from '../types';

const SUBMISSION_ITEM_IDS = [CaseSidebarItemId.SUBMIT_DIP, CaseSidebarItemId.SUBMIT_APPLICATION];

function hasSubmissionSidebarItem(applicationSectionItems: CaseSidebarItemId[]): boolean {
  return SUBMISSION_ITEM_IDS.some(itemId => applicationSectionItems.includes(itemId));
}

function resolveSectionItemIds(
  section: CaseSidebarSection,
  availablePages: Record<CaseSidebarSection, CaseSidebarItemId[]>,
): CaseSidebarItemId[] {
  if (section !== CaseSidebarSection.OTHER) {
    return availablePages[section];
  }

  if (hasSubmissionSidebarItem(availablePages[CaseSidebarSection.APPLICATION])) {
    return availablePages[section];
  }

  if (availablePages[section].includes(CaseSidebarItemId.ADDITIONAL_INFORMATION)) {
    return availablePages[section];
  }

  return [...availablePages[section], CaseSidebarItemId.ADDITIONAL_INFORMATION];
}

export function getVisibleItemIdsForSection(
  section: CaseSidebarSection,
  application: BtlApplication,
  featureFlags: CaseSidebarFeatureFlags = {},
): CaseSidebarItemId[] {
  const availablePages = getAvailablePagesForStatus(application.status);
  const sectionItemIds = resolveSectionItemIds(section, availablePages);

  return sectionItemIds.filter(itemId => isItemVisible(itemId, section, application, featureFlags));
}

export function getVisibleSidebarItemIds(
  application: BtlApplication,
  featureFlags: CaseSidebarFeatureFlags = {},
): CaseSidebarItemId[] {
  return CASE_SIDEBAR_SECTIONS.flatMap(section => getVisibleItemIdsForSection(section, application, featureFlags));
}
